import AdtProductListingPanel from "./adtProductListingPanel.container";

export default AdtProductListingPanel;
